import folderId from 'owa-service/lib/factory/folderId';
import type FolderInfoResponseMessage from 'owa-service/lib/contract/FolderInfoResponseMessage';
import folderResponseShape from 'owa-service/lib/factory/folderResponseShape';
import getFolderOperation from 'owa-service/lib/operation/getFolderOperation';
import getFolderRequest from 'owa-service/lib/factory/getFolderRequest';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export function getFolder(targetFolderId: string): Promise<FolderInfoResponseMessage> {
    // Currently this service command is only used to refresh folder counts, so no other properties are fetched
    return getFolderOperation({
        Header: getJsonRequestHeader(),
        Body: getFolderRequest({
            FolderShape: folderResponseShape({
                BaseShape: 'IdOnly',
                AdditionalProperties: [
                    propertyUri({ FieldURI: 'UnreadCount' }),
                    propertyUri({ FieldURI: 'TotalCount' }),
                ],
            }),
            FolderIds: [folderId({ Id: targetFolderId })],
        }),
    }).then(response => response.Body.ResponseMessages.Items[0]);
}
